import { useEffect, useState } from 'react';

import { DatePicker } from '../DatePicker';

export interface ActionBarDateFilterProps {
  onChange: (value: Date | null) => void;
  value: Date | null;
  disabled?: boolean;
  label?: string;
  maxDate?: Date;
  minDate?: Date;
  placeholder?: string;
}

export default function ActionBarDateFilter(props: ActionBarDateFilterProps) {
  const { onChange, value, maxDate, minDate, disabled = false, placeholder } = props;

  const [internalValue, setInternalValue] = useState<Date | null>(value);

  const handleChange = (date: Date | null) => {
    setInternalValue(date);
    onChange(date);
  };

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  return (
    <DatePicker
      selected={internalValue}
      onChange={handleChange}
      minDate={minDate}
      maxDate={maxDate}
      inputProps={{ size: 'md' }}
      disabled={disabled}
      placeholderText={placeholder}
      clampDateOutOfRange
      // TODO (@walter-24) input에 표시할 prefix text 지정할 수 있어야 함
      // TODO (@walter-24) onOpen, onClose 인터페이스 필요
      // FIXME (@walter-24) DateFilter나 DateRangeFilter가 두 개 이상 있으면, Popover가 표시되지 않는 버그
    />
  );
}
